import { ClassesInfoStructureType, Employee, SubjectType } from './types';

export const verifySingleClassDetail = (classInfo: ClassesInfoStructureType): boolean => {
  if (classInfo.class && classInfo.educationBoard && classInfo.section) {
    return true;
  } else {
    return false;
  }
};

export const employeeDetailsValidation = (data: Employee | undefined): string => {
  if (!data) return 'Employee data is required';
  if (!data.employeeId) return 'Employee Id is required';
  if (!data.fullName) return 'Employee name is required';
  if (!data.contactNumber) return 'Contact number is required';
  if (!data.emailAddress) return 'Email address is required';
  if (!data.dateOfBirth) return 'Date of birth is required';
  if (!data.dateOfJoining) return 'Date of joining is required';

  // Validate homeAddress
  if (!data.homeAddress) return 'Home address is required';
  if (!data.homeAddress.addressLine1) return 'Address Line 1 is required';
  if (!data.homeAddress.country) return 'Country is required';
  if (!data.homeAddress.state) return 'State is required';
  if (!data.homeAddress.city) return 'City is required';
  if (!data.homeAddress.pincode) return 'Pincode is required';

  if (!data.jobTitle) return 'Job title is required';
  if (!data.employmentType) return 'Employment type is required';

  if (!data.totalExperienceMonths) return 'Total experience (in months) is required';
  return '';
};

export const shouldDisableAddSubject = (data: ClassesInfoStructureType, lastSubject: SubjectType) => {
  if (lastSubject) {
    if (lastSubject.subjectCode.trim() === '' || lastSubject.subjectName.trim() === '') {
      return true;
    }
  }
  if (!data.class || !data.educationBoard || !data.section) {
    return true;
  }
  return false;
};
